import React, { useEffect } from 'react';
import { useParams } from 'ice';
import { Servlets } from '@/service';

/**
 * 支付宝支付页面
 * @param outTradeNo-订单编号
 */
function PayDeals() {
  const { outTradeNo } = useParams();

  useEffect(() => {
    // subject: 订单名称，需要前端自己生成
    Servlets('alipay', { outTradeNo }).then((res) => {
      const divs = document.createElement('div');
      divs.innerHTML = res.data.replace('<script>document.forms[0].submit();</script>', ''); // html code
      document.body.appendChild(divs);
      document.forms.punchout_form.submit();
    });
  }, []);

  return (
    <>
    </>
  );
}

export default PayDeals;
